(function ($) {
	// Show subs toggle
	var toggleLink = $('.toggle-link'),
		activeClass = 'active',
		toggleCopy = $('.toggled-copy');

	toggleCopy.hide();

	toggleLink.click(function () {
		var toggleControl = $(this).attr('aria-controls'),
			toggledDiv = $('div#' + toggleControl);

		$(this).toggleClass('open');

		if ($(window).width() < 840) {
			var aTag = $(this);
			$(this).toggleClass(activeClass);
			if ($(this).hasClass(activeClass)) {
				$('html,body').animate({ scrollTop: aTag.offset().top - 150 }, 400);
			}
		}

		toggledDiv.slideToggle();

		return false;
	});
})(window.jQuery);
